import { render, staticRenderFns } from "./TemplateCard.vue?vue&type=template&id=5425c77d&scoped=true&"
import script from "./TemplateCard.vue?vue&type=script&lang=js&"
export * from "./TemplateCard.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCard.vue?vue&type=style&index=0&id=5425c77d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5425c77d",
  null
  
)

export default component.exports